import React, { useRef, useEffect } from 'react';
import QRCode from 'qrcode';
import { useSelector, useDispatch } from 'react-redux';
import { MD_MODAL, StaticModalWindow } from '@yme/atoms/modal-window';
import { getCartQrId } from '@yme/common/redux/cart/selectors';
import { getDealersToolsLabels } from '@yme/components/CheckoutForm/redux/selectors';
import { getUserAccountDealerId } from '@yme/components/Header/ProfileMenu/redux/selectors';
import { setIsModalHide } from '@yme/modals/actions';
import { getRTL } from '@yme/selectors/common';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { setDigitalData, DigitalDataMutation } from '@yme/utils/common';
import { QR_CODE_WIDTH, SHARE_CART_BY_QR_MODAL_TEST_ID } from './constants';
import { generateCartUrl } from './helpers';
import { QrCodeWrapperStyled } from './styled';
export function ShareCartByQrModal() {
    const isRightToLeft = useSelector(getRTL);
    const dealersToolsLabels = useSelector(getDealersToolsLabels);
    const cartQrId = useSelector(getCartQrId);
    const userAccountDealerId = useSelector(getUserAccountDealerId);
    const dispatch = useDispatch();
    const canvasRef = useRef(null);
    const cartUrl = generateCartUrl(cartQrId, userAccountDealerId);
    useEffect(() => {
        if (canvasRef.current) {
            if (userAccountDealerId) {
                setDigitalData(DigitalDataMutation.CART_SHARE_QR, {
                    dealerId: userAccountDealerId,
                });
            }
            QRCode.toCanvas(canvasRef.current, cartUrl, {
                margin: 0,
                width: QR_CODE_WIDTH,
            });
        }
    }, [cartUrl, userAccountDealerId]);
    const handleHideModal = () => {
        dispatch(setIsModalHide());
    };
    return (React.createElement(StaticModalWindow, { title: dealersToolsLabels.checkout_dealersToolsShareViaQRPopUp_header, staticModalSize: MD_MODAL, minHeight: "auto", isRightToLeft: isRightToLeft, dataTestId: SHARE_CART_BY_QR_MODAL_TEST_ID, onHide: handleHideModal },
        React.createElement(FlexWrapper, { flexDirection: "column", gap: INDENT.xs },
            React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, dealersToolsLabels.checkout_dealersToolsShareViaQRPopUp_description),
            React.createElement(QrCodeWrapperStyled, null,
                React.createElement("canvas", { ref: canvasRef })),
            React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, dealersToolsLabels.checkout_dealersToolsShareViaQRPopUp_hint))));
}
